module.exports = __webpack_public_path__ + "media/images/home/ic_delete-5180f87a484cfcb17c752abb7435bcac.svg";